import RawModel from '@/app/assets/components/upload/atoms/RawModel';
import { Text, Stack } from '@mantine/core';
import { ErrorAlert, InfoAlert, WarningAlert } from '@/app/components/alerts/alerts';
import { FileValidationErrors } from '@/app/assets/components/upload/hooks/useFileValidation';
import { getFileExtension } from '@/utils/fileUtils';
import { useAssetsUploadContext } from '../contexts/useAssetsUploadContext';
type RawModelListProps = {
  onRemoveAsset: (index: number) => void;

  validationErrors: FileValidationErrors;
  isUploadPending: boolean;
};

const hasKeys = (obj: Record<any, any> | undefined) => !!(obj && Object.keys(obj).length);

export default function RawModelList({
  className,
  onRemoveAsset,
  validationErrors,
  isUploadPending,
}: RawModelListProps & { className?: string }) {
  const { filesWithMetadata: rawModels, addTag, removeTag } = useAssetsUploadContext();
  return (
    <Stack gap={20} className={className} align='center'>
      <Stack gap='xs' align='center' w={425}>
        {hasKeys(validationErrors.general?.errors) && (
          <ErrorAlert>
            {Object.keys(validationErrors.general?.errors!).map((err) => (
              <Text key={err} size='sm'>
                {validationErrors.general?.errors[err]}
              </Text>
            ))}
          </ErrorAlert>
        )}
        {hasKeys(validationErrors.general?.warnings) && (
          <WarningAlert>
            {Object.keys(validationErrors.general?.warnings!).map((err) => (
              <Text key={err} size='sm'>
                {validationErrors.general?.warnings[err]}
              </Text>
            ))}
          </WarningAlert>
        )}
        {hasKeys(validationErrors.general?.infos) && (
          <InfoAlert>
            {Object.keys(validationErrors.general?.infos!).map((err) => (
              <Text key={err} size='sm'>
                {validationErrors.general?.infos[err]}
              </Text>
            ))}
          </InfoAlert>
        )}
      </Stack>
      {!!rawModels.length &&
        rawModels.map(({ file, tags }, index) => (
          <Stack key={`${file.path}_${index}`} w='100%'>
            <RawModel
              isUploadPending={isUploadPending}
              path={file.path}
              name={file.name}
              extension={getFileExtension(file)}
              size={file.size}
              onRemoveAsset={() => onRemoveAsset(index)}
              tags={tags}
              addTag={(tag) => addTag(index, tag)}
              removeTag={(tag) => removeTag(index, tag)}
              validationError={
                <Stack gap='xs' align='center' w={425}>
                  {validationErrors.files[file.name] && (
                    <ErrorAlert>
                      {[...new Set(validationErrors.files[file.name])].map((err, index) => (
                        <Text key={index} size='sm'>
                          {err}
                        </Text>
                      ))}
                    </ErrorAlert>
                  )}
                </Stack>
              }
            />
          </Stack>
        ))}
    </Stack>
  );
}
